import React, { useState } from "react";
import Layout from "../../layout";
import { Loader } from "../../loader";
import Close from "../../../assets/images/close.png";
import Gift from "../../../assets/images/giftRupee.png";
import Rupee from "../../../assets/images/Indian-Rupee-Symbol.gif";
import Rupeesymbol from "../../../assets/images/rupeesymbol.png";
import CashReward from "../../../assets/images/cashReward.png";
import GiftReward from "../../../assets/images/giftReward.png";
import SuccessIcon from "../../../assets/images/successIcon.png";
import extraBonus from "../../../assets/images/extra bonus.png";
import SpinImageHi from "../../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../../assets/images/spinImage_te.png";
import SpinImageGj from "../../../assets/images/spinImage_gj.png";
import SpinImagePb from "../../../assets/images/spinImage_pb.png";
import SpinImageTa from "../../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../../assets/images/spinImage_en.png";
import SpinImageOr from "../../../assets/images/spinImage_or.png";
import SpinImageMa from "../../../assets/images/spinImage_ma.png";
import { Button } from "react-bootstrap";
import CustomModal from "../../modal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAPI } from "../../service/Encrtyption";
import { myRewards } from "../../auth/redux/store";
import ScanMoreImg from '../../../assets/images/Scanmore.png';
import ReactGA from 'react-ga4';
export const GiftClaim = () => {
    const obj = {
        cashFreeTransactionId: 0,
        dsrId: 0,
        ecouponFarmerMapId: 0,
        moduleType: "Farmer",
        programId: 0,
        reClaim: "No",
        showView: false,
        countOfToBeClaims: 0,
        dsrProgramId: 0,
        ecouponFarmerId: 0,
        enableSprayService: false,
        isCortevaProduct: false,
        isLumivia: false,
        isProductAlreadyScaned: false,
        isSpinDone: false,
        lumiviaServReqRecordID: 0,
        multipleRewards: false,
        seadProgramId: 0,
        showClickableLink: false,
        showLuckyWinnerPopup: false,
        showRetailerIdPopup: false,
        uq_responseCode: 0,
        wheelStoppingIndex: 0,
        destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V2",
    };
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(obj);
    const user = useSelector((state) => state?.user);
    const genunityData = useSelector((state) => state?.genunityData);
    const secondaryMessage = useSelector((state) => state?.message);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mobileNumber = sessionStorage.getItem('mbn');
    const [errroMsg, setErrorMsg] = useState("");
    const browserType = sessionStorage.getItem("browserName") || "web";


    const hide = () => {
        setErrorMsg("");
    };


    const primaryRewardMsg = genunityData?.primaryRewardMsg;
    const multipleRewards = genunityData?.multipleRewards;
    const primaryRewardAmount = genunityData?.cashRewards;
    const bonusAmount = genunityData?.bonus;
    // const mobileNumber = user?.mobileNumber;
    const giftType = genunityData.cashRewards;


    let bannerLogoSrc;
    if (lang === 'hi') {
        bannerLogoSrc = SpinImageHi;
    } else if (lang === 'mr') {
        bannerLogoSrc = SpinImageMr;
    } else if (lang === 'kn') {
        bannerLogoSrc = SpinImageKa;
    } else if (lang === 'te') {
        bannerLogoSrc = SpinImageTe;
    } else if (lang === 'pa') {
        bannerLogoSrc = SpinImagePb;
    } else if (lang === 'gu') {
        bannerLogoSrc = SpinImageGj;
    } else if (lang === 'ta') {
        bannerLogoSrc = SpinImageTa;
    } else if (lang === 'bn') {
        bannerLogoSrc = SpinImageBn;
    } else if (lang === 'en') {
        bannerLogoSrc = SpinImageEn;
    } else if (lang === 'or') {
        bannerLogoSrc = SpinImageHi;
    } else if (lang === 'ma') {
        bannerLogoSrc = SpinImageHi;
    }
    else {
        bannerLogoSrc = SpinImageHi;
    }


    return (
        <>
            <Layout>
                <div className="container p-0">
                    {loading && <Loader />}
                    <div className="card border-0">
                        <div className="card-body px-2 pt-0 pb-2">
                            <div className="container text-center mt-4">
                                <div className="text-center rewardContent" style={{ height: "170px" }}>
                                    <img src={genunityData?.giftImageURL} alt="gift" className="img-fluid" />
                                </div>

                                <div style={{ marginTop: '7rem', marginBottom: '7rem' }}>
                                    <h5 className="card-title mb-1"> {t('thankYouForPurchase')}</h5>
                                    <p className="card-text mb-0">  {t('alreadyWonGift')}</p>
                                </div>

                                <div className="d-flex flex-direction-column bottomBtns" style={{ gap: '1rem' }}
                                    onClick={() => {
                                        ReactGA.event({
                                            category: 'GiftClaim',
                                            label: 'Reward History',
                                            action: 'Reward History'
                                        });
                                        navigate(`/${lang}/giftHistory`);
                                    }}
                                >
                                    <Button className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}>
                                        {t('reward_history')}
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Layout >
        </>
    );
};
